import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

const withKioskAuth = (ComposedComponent) => {
  const mapStateToProps = (state) => ({
    isAuthenticated: state.profile.auth.isAuthenticated,
    isAuthenticating: state.profile.auth.isAuthenticating,
    userProfileLoaded: state.profile.user.userProfileLoaded,
    loginType: state.profile.auth.loginType,
  });

  class KioskAuthenticatedContainer extends Component {
    UNSAFE_componentWillMount() {
      this.checkAuth(this.props);
    }

    UNSAFE_componentWillReceiveProps(props) {
      this.checkAuth(props);
    }

    checkAuth(props) {
      if (!props.isAuthenticated || props.loginType.toLowerCase() !== 'patientkioskmanagement') {
        this.redirectToLogin();
      }
    }

    redirectToLogin() {
      this.props.history.push('/kioskLogin');
    }

    render() {
      const { isAuthenticated } = this.props;
      return (
        <div>
          {
            isAuthenticated ?
              <ComposedComponent {...this.props} /> :
              null
          }
        </div>
      );
    }
  }

  KioskAuthenticatedContainer.propTypes = {
    dispatch: PropTypes.func,
    history: PropTypes.object,
    isAuthenticated: PropTypes.bool,
    isAuthenticating: PropTypes.bool,
    userProfileLoaded: PropTypes.bool,
    loginType: PropTypes.string,
  };

  return withRouter(connect(mapStateToProps)(KioskAuthenticatedContainer));
};

export {
  withKioskAuth,
};
